
<template>
<div class="w-full">
  <vx-card>
    <vs-input class="w-full" label="주관식 답지" v-model="answer" />
    <vs-input class="w-full" label="입력 예제" v-model="ex_answer" />
  </vx-card>

</div>
</template>

<script>
export default {
  data() {
    return {
      answer: '',
      ex_answer:'',
    }
  },
  methods: {},
  watch: {
    answer() {
      this.$store.commit('etest/SET_ANSWER', {answer:this.answer, ex_answer:this.ex_answer})
    },
    ex_answer(){
      this.$store.commit('etest/SET_ANSWER', {answer:this.answer, ex_answer:this.ex_answer})
    },
    activeQuestionId() {
      this.answer = this.activeQuestion.answer
    }
  },
  computed: {
    activeQuestionId() {
      return this.$store.state.etest.activeQuestion.id
    },
    activeQuestion() {
      return this.$store.state.etest.activeQuestion
    },
  },
  created() {
    this.answer = this.activeQuestion.answer
    this.ex_answer = this.activeQuestion.ex_answer
  }
}
</script>
